import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IoMdGlobe, IoMdPeople, IoMdCalendar, IoMdMusicalNotes, IoMdMicrophone, IoMdAddCircle, IoMdRemoveCircle, IoMdPricetags } from 'react-icons/io'; 
import voiceStore from '../stores/voiceStore';
import CreatableSelect from 'react-select/creatable';
import { FaTimes } from 'react-icons/fa';
import { Bars } from "react-loader-spinner";
const SearchNavV2 = observer(class SearchNav extends Component {
    state = {
        isLanguageOpen: false,
        showMoreLanguages: false,
    };

    toggleDropdown = (type) => {
        this.setState((prevState) => ({
            [`is${type}Open`]: !prevState[`is${type}Open`],
        }));
    };

    toggleShowMoreLanguages = () => {
        this.setState((prevState) => ({
            showMoreLanguages: !prevState.showMoreLanguages,
        }));
    };

    handleSelectChange = (type, value) => {
        const { searchPayload } = voiceStore;

        const selectedValues = [...searchPayload[type]];
        const index = selectedValues.indexOf(value);

        if (index === -1) {
            
            selectedValues.push(value);
        } else {
            
            selectedValues.splice(index, 1);
        }

        voiceStore.updatePayload({ [type]: selectedValues });
    };

    sortOptions = (options, selectedValues) => {
        const selectedOptions = options.filter(option => selectedValues.includes(option.value));
        const unselectedOptions = options.filter(option => !selectedValues.includes(option.value));

        return [...selectedOptions, ...unselectedOptions];
    };

    componentDidMount() {
        if(window.innerWidth >= 1024){
            voiceStore.setSearchNavVisible(true);
        }
    }

    render() {
        const { languageOptions, accentOptions, genderOptions, ageGroupOptions, styleOptions } = voiceStore.dropdownData;
        const { isLanguageOpen, showMoreLanguages } = this.state;

        const sortedLanguageOptions = this.sortOptions(languageOptions, voiceStore.searchPayload.languages);
        const sortedAccentOptions = this.sortOptions(accentOptions, voiceStore.searchPayload.accents);
        const sortedGenderOptions = this.sortOptions(genderOptions, voiceStore.searchPayload.gender);
        const sortedAgeGroupOptions = this.sortOptions(ageGroupOptions, voiceStore.searchPayload.age);
        const sortedStyleOptions = this.sortOptions(styleOptions, voiceStore.searchPayload.style);

        return (
            <div className="flex flex-col items-center gap-4 w-full absolute top-0 bg-white h-screen border border-t-2 border-r-2 lg:w-48 lg:static lg:bg-white p-2 rounded-md">
                <div className='flex justify-between mx-4 mt-5 mb-5 lg:hidden'>
                    <FaTimes onClick={()=>{
                        voiceStore.setSearchNavVisible(false);
                    }} />
                </div>
                <span className='font-semibold text-lg text-[#130D0D] px-4'>Search Filters</span>

                <div className='flex flex-col gap-4 w-full lg:w-40 '>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isGenderOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdPeople className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Gender</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Gender')}
                            >
                                {this.state.isGenderOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {this.state.isGenderOpen && (
                            <div className="space-y-2 mt-2 px-4">
                                {sortedGenderOptions.map(({ value, label }) => (
                                    <div key={value} className="flex items-center justify-between space-x-2">
                                        <label className='font-normal text-sm text-[#130D0D]'>{label}</label>
                                        <input
                                            type="checkbox"
                                            checked={voiceStore.searchPayload.gender.includes(value)}
                                            onChange={() => this.handleSelectChange('gender', value)}
                                            className="w-4 h-4 border-gray-300 rounded checked:bg-black checked:border-black"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isLanguageOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdGlobe className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Languages</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Language')}
                            >
                                {isLanguageOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {isLanguageOpen && (
                            <div className="space-y-2 mt-2 px-4">
                                {sortedLanguageOptions.slice(0, showMoreLanguages ? languageOptions.length : 10).map(({ value, label }) => (
                                    <div key={value} className="flex items-center justify-between space-x-2">
                                        <label className='font-normal text-sm text-[#130D0D]'>{label}</label>
                                        <input
                                            type="checkbox"
                                            checked={voiceStore.searchPayload.languages.includes(value)}
                                            onChange={() => this.handleSelectChange('languages', value)}
                                            className="w-4 h-4 border-gray-300 rounded checked:bg-black checked:border-black"
                                        />
                                    </div>
                                ))}
                                {!showMoreLanguages && languageOptions.length > 10 && (
                                    <button
                                        className="text-blue-500 mt-2"
                                        onClick={this.toggleShowMoreLanguages}
                                    >
                                        show more...
                                    </button>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isAccentOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdMicrophone className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Accents</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Accent')}
                            >
                                {this.state.isAccentOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {this.state.isAccentOpen && (
                            <div className="space-y-2 mt-2 px-4">
                                {sortedAccentOptions.map(({ value, label }) => (
                                    <div key={value} className="flex items-center justify-between space-x-2">
                                        <label className='font-normal text-sm text-[#130D0D]'>{label}</label>
                                        <input
                                            type="checkbox"
                                            checked={voiceStore.searchPayload.accents.includes(value)}
                                            onChange={() => this.handleSelectChange('accents', value)}
                                            className="w-4 h-4 border-gray-300 rounded checked:bg-black checked:border-black"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isAgeOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdCalendar className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Age</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Age')}
                            >
                                {this.state.isAgeOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {this.state.isAgeOpen && (
                            <div className="space-y-2 mt-2 px-4">
                                {sortedAgeGroupOptions.map(({ value, label }) => (
                                    <div key={value} className="flex items-center justify-between space-x-2">
                                        <label className='font-normal text-sm text-[#130D0D]'>{label}</label>
                                        <input
                                            type="checkbox"
                                            checked={voiceStore.searchPayload.age.includes(value)}
                                            onChange={() => this.handleSelectChange('age', value)}
                                            className="w-4 h-4 border-gray-300 rounded checked:bg-black checked:border-black"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isStyleOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdMusicalNotes className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Style</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Style')}
                            >
                                {this.state.isStyleOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {this.state.isStyleOpen && (
                            <div className="space-y-2 mt-2 px-4">
                                {sortedStyleOptions.map(({ value, label }) => (
                                    <div key={value} className="flex items-center justify-between space-x-2">
                                        <label className='font-normal text-sm text-[#130D0D]'>{label}</label>
                                        <input
                                            type="checkbox"
                                            checked={voiceStore.searchPayload.style.includes(value)}
                                            onChange={() => this.handleSelectChange('style', value)}
                                            className="w-4 h-4 border-gray-300 rounded checked:bg-black checked:border-black"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div className={`flex justify-between items-center p-2 ${this.state.isAdditionalOpen && 'bg-[#FCD49F]'}`}>
                            <IoMdPricetags className="text-xl text-[#130D0D]" />
                            <label className="text-sm font-normal text-[#130D0D]">Additional</label>
                            <button
                                className="text-xl"
                                onClick={() => this.toggleDropdown('Additional')}
                            >
                                {this.state.isAdditionalOpen ? <IoMdRemoveCircle /> : <IoMdAddCircle />}
                            </button>
                        </div>
                        {this.state.isAdditionalOpen && (
                            <div className="space-y-2 mt-2">
                                <CreatableSelect
                                    isMulti
                                    placeholder="Enter text..."
                                    value={voiceStore.searchPayload.additionalTags.map(tag => ({ value: tag, label: tag }))}
                                    onChange={(selectedOptions) => {
                                        const newTags = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        voiceStore.updatePayload({ additionalTags: newTags });
                                    }}
                                    onCreateOption={(inputValue) => {
                                        voiceStore.updatePayload({
                                            additionalTags: [...voiceStore.searchPayload.additionalTags, inputValue],
                                        });
                                    }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                    isClearable
                                />
                            </div>
                        )}
                    </div>

                </div>
                <button onClick={() => {
                    voiceStore.searchVoiceIndex();
                    if(window.innerWidth < 1024){
                        voiceStore.setSearchNavVisible(false);
                    }
                }} className="bg-[#130D0D] text-white font-medium text-base w-32 py-2 px-4 rounded">
                {!voiceStore.loadResult && <span>Search</span>}
                              <Bars
                                height="25"
                                width="25"
                                color="#F89A1F"
                                ariaLabel="bars-loading"
                                visible={voiceStore.loadResult}
                              />
                            </button>
                <div style={{height: 140}}>&nbsp;</div>
                 <div style={{height: 140}}>&nbsp;</div>
            </div>
        );
    }
});

export default SearchNavV2;
